import { render, staticRenderFns } from "./V2Connections.vue?vue&type=template&id=46b4b0fc&scoped=true&"
import script from "./V2Connections.vue?vue&type=script&lang=js&"
export * from "./V2Connections.vue?vue&type=script&lang=js&"
import style0 from "./V2Connections.vue?vue&type=style&index=0&id=46b4b0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b4b0fc",
  null
  
)

export default component.exports